import React from 'react';
import { CalendlyEventListener } from 'react-calendly';
import TimeSlot from 'src/components/ServiceRequestForm/TimeSlot/TimeSlot';
import { PreferredServiceDay } from 'src/components/ServiceRequestForm/TimeSlot/timeSlotHelpers';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import './calendly-scheduling-panel.scss';

interface CalendlySchedulingPanelProps {
  preferredServiceTimes: PreferredServiceDay[];
  calendlyEmbedUrl: string;
  onTimeSlotSelection: (selection: string) => Promise<void>;
  onCalendlyEventScheduled: (event: any) => void;
}

const CalendlySchedulingPanel = ({
  preferredServiceTimes,
  calendlyEmbedUrl,
  onTimeSlotSelection,
  onCalendlyEventScheduled,
}: CalendlySchedulingPanelProps) => {
  const CalendlyListener = CalendlyEventListener as any;

  return (
    <div className="calendly-scheduling-panel">
      <Row>
        <Col xs="12" md="6">
          <TimeSlot
            fromScheduling={preferredServiceTimes}
            onSelectionChange={(selection: string) =>
              void onTimeSlotSelection(selection)
            }
          />
        </Col>
        <Col xs="12" md="6">
          <CalendlyListener
            onEventScheduled={(event: any) => onCalendlyEventScheduled(event)}
          >
            <div className="calendly-embed-frame">
              <iframe src={calendlyEmbedUrl} title="Calendly scheduling" />
            </div>
          </CalendlyListener>
        </Col>
      </Row>
    </div>
  );
};

export default CalendlySchedulingPanel;